import { AxiosRequestConfig } from 'axios';
import axiosClient from './axiosClient';

// El interceptor de axiosClient ya devuelve response.data
// Por lo tanto, aquí NO debemos hacer .data otra vez

export const get = async <T>(url: string, config?: AxiosRequestConfig): Promise<T> => {
  return (await axiosClient.get<T>(url, config)) as T;
};

export const post = async <T>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<T> => {
  return (await axiosClient.post<T>(url, data, config)) as T;
};

export const patch = async <T>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<T> => {
  return (await axiosClient.patch<T>(url, data, config)) as T;
};

export const del = async (url: string, config?: AxiosRequestConfig): Promise<void> => {
  await axiosClient.delete(url, config);
};

export const put = async <T>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<T> => {
  return (await axiosClient.put<T>(url, data, config)) as T;
};
